import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import { HttpResponse } from 'shell/models/http-response';
import { NonRecoverable } from 'shell/models/non-recoverable-error';

export interface transformNonRecoverableErrorResponse {
  id?: string;
  operatorCode?: string;
  microService?: string;
  httpMethod?: string;
  api?: string;
  dateTimePublication: DateTime | null;
  eventData?: string;
  eventDescription?: string;
}

export const trasformNonRecoverableError = (
  response: AxiosResponse<HttpResponse<NonRecoverable>>
): transformNonRecoverableErrorResponse => {
  const data: NonRecoverable = response.data.payload || {};
  const res: transformNonRecoverableErrorResponse = {
    id: data?.jmsMessageID || '',
    eventDescription: data?.stackTrace,
    dateTimePublication: data?.timeStampErrore ? data.timeStampErrore : null,
    operatorCode: data?.codiceOperatore || '',
    microService: data?.microservizio || '',
    api: data?.apiEndpoint || '',
    eventData: data?.stackTrace || '',
    httpMethod: data?.metodoHTTP,
  };
  return res;
};
